<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="despatchRef" :options="item.options" :lablewith="item.lablewith"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :event="item.event"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup :show="showorhide" :qhide="false" @showclick="showclick" @hide="hide" @select="select"
						@reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<ConsignStockByCustomertable :tableData="tableData" :total="total" @Export="Export"
					@DownloadTemplet="DownloadTemplet" @Import="Import"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</ConsignStockByCustomertable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '@/components/common-dropdownlist.vue'
	import CommonBtngroup from '@/components/commongroup.vue'
	import ConsignStockByCustomertable from './components/ConsignStockByCustomertable.vue'
	import utils from '@/common/utils'
	import { InventoryClassList, GetProvince } from '@/api/home'
	import {
		ConsignStockByCustomerList,
		ConsignStockByCustomerExport,
		ConsignStockByCustomerDownloadTemplet,
		ConsignStockByCustomerImport
	} from '@/api/ConsignStockByCustomer'

	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			ConsignStockByCustomertable,
		},
		data() {
			return {
				total: 0,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				showorhide: true,
				formdata: [
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'selectMultiple',
						width: '200px',
						options: [],
						lablewith: '100px',
						event: ''
					},
					{
						inputdata: '',
						title: '产品',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '省份',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'selectMultiple',
						width: '200px',
						options: [],
						lablewith: '100px',
						event: ''
					}
				],
				from: {
					InvClass: "",
					Inventory: "",
					ProvinceID: ""
				}
			}
		},
		mounted() {
			this.inventoryClassList()
			this.getProvince()
			this.getList()
		},
		methods: {
			// 获取省份
			async getProvince() {
				let { code, data } = await GetProvince({})
				if (code == 0) {
					try {
						this.formdata[2].options = []
						let list = data || []
						list.map((item, index) => {
							let obj = {
								key: item.Value,
								value: item.Text
							}
							this.formdata[2].options.push(obj)
						})
					} catch (error) {}
				}
			},
			// 获取产品线下拉
			async inventoryClassList() {
				let { code, data } = await InventoryClassList({})
				if (code == 0) {
					try {
						this.formdata[0].options = []
						let list = data.data || data.Data || data || []
						list.map((item, index) => {
							let obj = {
								key: item.InvClass,
								value: item.InvClassName
							}
							this.formdata[0].options.push(obj)
						})
					} catch (error) {}
				}
			},
			// 列表
			async getList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let { data, code, message } = await ConsignStockByCustomerList({
					InvClass: this.from.InvClass,
					Inventory: this.from.Inventory,
					ProvinceID: this.from.ProvinceID,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (code == 0) {
					this.total = data.Count || data.Total || 0;
					this.tableData = data.data || data.Data || data || [];
				} else {
					this.$message.warning(message)
				}
				loading.close();
			},
			// 导出
			async Export() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await ConsignStockByCustomerExport({
					InvClass: this.from.InvClass,
					Inventory: this.from.Inventory,
					ProvinceID: this.from.ProvinceID,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `寄售库存${str}`, "xlsx")
				} else {
					this.$message.warning('导出失败');
				}
				loading.close()
			},
			// 下载模板
			async DownloadTemplet() {
				const loading = this.$loading({
					lock: true,
					text: '正在下载模板...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let { data, code, message } = await ConsignStockByCustomerDownloadTemplet()
				if (code == 0) {
					window.location.href = data;
				} else {
					this.$message.warning(message || '下载失败');
				}
				loading.close()
			},
			// 导入
			async Import(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在导入...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formData = new FormData();
				formData.append('file', file);
				let { code, message, data } = await ConsignStockByCustomerImport(formData);
				if (code == 0) {
					this.$message.success('导入成功');
					this.getList();
				} else if (code === 2 || (data && Array.isArray(data) && data.length > 0)) {
					this.$confirm(`<strong>${message}</strong><br/>${data.join(',<br/>')}`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						dangerouslyUseHTMLString: true
					}).catch(() => { });
				} else {
					this.$message.warning(message || '导入失败');
				}
				loading.close()
			},
			// 清空
			reset() {
				let refs = this.$refs.despatchRef || []
				refs.map((item, index) => {
					item.modelvalue = ''
				})
				this.from.InvClass = "";
				this.from.Inventory = "";
				this.from.ProvinceID = "";
			},
			hide() {
				this.showorhide = false
			},
			showclick() {
				this.showorhide = true
			},
			select() {
				this.pageindex = 1
				try {
					this.from.InvClass = this.$refs.despatchRef[0].modelvalue ? this.$refs.despatchRef[0].modelvalue.join(',') : ''
					this.from.Inventory = this.$refs.despatchRef[1].modelvalue || ''
					this.from.ProvinceID = this.$refs.despatchRef[2].modelvalue ? this.$refs.despatchRef[2].modelvalue.join(',') : ''
					this.getList()
				} catch (error) {
					this.getList()
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.getList()
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.getList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 90px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 44px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 400px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 45px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}

	.TableBox{
		margin-bottom: 60px;
	}
</style>
